/**
 * `/$org/apps/custom/$serverId`: one of the organization's custom MCP
 * servers, inside Apps. `custom/` keeps server ids apart from app ids.
 *
 * @module routes/$org.apps.custom.$serverId
 */
import { createFileRoute, redirect } from "@tanstack/react-router";

import { AppsFrame } from "../components/apps/AppsFrame";
import { CustomMcpServerPage } from "../components/apps/integrations/CustomMcpServerPage";
import { useRegulationOrg } from "../components/regulation/useRegulationOrg";

function CustomMcpServerRouteView() {
  const { org: orgSegment, serverId } = Route.useParams();
  const { org } = useRegulationOrg();
  return (
    <AppsFrame>
      <CustomMcpServerPage
        key={`${org?.id ?? ""}:${serverId}`}
        organizationId={org?.id ?? null}
        orgSegment={orgSegment}
        serverId={serverId}
      />
    </AppsFrame>
  );
}

export const Route = createFileRoute("/$org/apps/custom/$serverId")({
  beforeLoad: async ({ context }) => {
    if (
      context.authGateState.status !== "authenticated" &&
      context.authGateState.status !== "hosted-static"
    ) {
      throw redirect({ to: "/pair", replace: true });
    }
  },
  component: CustomMcpServerRouteView,
});
